// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__z6Qbc","visible":"Footer_visible__C+D3H","svgContainer":"Footer_svgContainer__MMDab"};